import React from 'react';
import { useReveal } from '../lib/useReveal';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/rsobJFFbh4rMvyeQSJa5ow/ChatGPT_Image_1_abr_2026,_15_24_19.png';
const BG_IMG = 'https://cdn.magicpatterns.com/uploads/w6mTwbYbwCmavTPC8PetFK/heylloyd-image-1774029715790.png';
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="min-h-screen pt-20 pb-8 md:pt-24 md:pb-12 px-4 sm:px-6 overflow-hidden relative flex flex-col justify-center" data-id="element-103">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${BG_IMG})`
    }} data-id="element-104"></div>
      <div className="absolute inset-0 bg-black/45" data-id="element-105"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-106">
        <div className="mb-4" data-id="element-107">
          <span className="text-[#eab308] text-xs md:text-sm font-bold tracking-[0.2em] uppercase" data-id="element-108">
            ⭐ ACADEMIA HOLÍSTICA ARGENTINA ⭐
          </span>
        </div>

        <h1 className="mb-4 font-serif font-bold tracking-tight leading-none text-white" data-id="element-109">
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-2" data-id="element-110">
            ¿Y si tu cuerpo no está fallando…
          </span>
          <span className="block text-[#eab308] text-4xl sm:text-5xl md:text-7xl lg:text-8xl" data-id="element-111">
            sino hablándote?
          </span>
        </h1>

        <p className="text-gray-300 mb-3 max-w-3xl mx-auto leading-relaxed px-2 text-lg md:text-xl font-medium" data-id="element-112">
          Descubrí el método que miles de personas usan para entender el mensaje
          detrás de cada enfermedad, bloqueo y patrón que se repite en tu vida
        </p>

        <p className="font-serif font-bold text-2xl sm:text-3xl md:text-4xl tracking-wide mb-4 text-transparent bg-clip-text bg-gradient-to-r from-[#b8860b] via-[#e8c44a] to-[#b8860b]" data-id="element-113">
          BIODECODIFICACION Integral
        </p>

        {/* Product Image */}
        <div className="block mx-auto max-w-xs sm:max-w-md md:max-w-lg mb-5" data-id="element-114">
          <div className="relative animate-float" data-id="element-115">
            <div className="absolute -inset-4 bg-gradient-to-br from-[#d4a017]/20 via-[#eab308]/10 to-[#d4a017]/15 rounded-3xl blur-2xl opacity-80" data-id="element-116"></div>
            <div className="relative p-1 rounded-2xl bg-gradient-to-br from-[#eab308]/30 via-white/5 to-[#eab308]/20 shadow-[0_12px_60px_rgba(184,134,11,0.25)] border border-[#d4a017]/20" data-id="element-117">
              <div className="rounded-xl overflow-hidden bg-black" data-id="element-118">
                <img src={PRODUCT_IMG} alt="BIODECODIFICACION Integral" className="w-full object-cover block" data-id="element-119" />
              </div>
            </div>
          </div>
        </div>

        {/* Quote */}
        <p className="text-transparent bg-clip-text bg-gradient-to-r from-[#b8860b] via-[#e8c44a] to-[#b8860b] font-serif font-bold italic text-xl md:text-2xl tracking-wide mb-4" data-id="element-120">
          "Tu cuerpo tiene las respuestas. Aprendé a escucharlo."
        </p>

        {/* Social proof */}
        <p className="text-gray-300 mb-5 max-w-2xl mx-auto leading-relaxed px-2 text-base md:text-lg" data-id="element-121">
          El programa que ya eligieron{' '}
          <span className="text-white font-bold" data-id="element-122">+1.000 alumnos</span> en
          Argentina para entender el lenguaje de su cuerpo.
        </p>

        {/* Pill Badges */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-4" data-id="element-123">
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-3 py-1 backdrop-blur-sm" data-id="element-124">
            📱 100% Digital
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-3 py-1 backdrop-blur-sm" data-id="element-125">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-3 py-1 backdrop-blur-sm" data-id="element-126">
            📖 6 Volúmenes completos
          </span>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-2 w-full max-w-xl mx-auto" data-id="element-127">
          <a href="#pricing" className="w-full block px-4 sm:px-6 py-4 md:py-5 rounded-xl text-[#0f0f1a] font-bold text-sm sm:text-base md:text-lg tracking-wider sm:tracking-widest uppercase transition-all shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50 text-center" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-128">
            🔥 QUIERO ENTENDER EL LENGUAJE DE MI CUERPO
          </a>
          <p className="text-gray-400 text-xs md:text-sm font-medium mt-1" data-id="element-129">
            💳 Mercado Pago — Tarjeta de crédito — Transferencia
          </p>
          <p className="text-gray-500 text-xs md:text-sm font-medium" data-id="element-130">
            🔒 Pago seguro — Acceso inmediato — Garantía total
          </p>
        </div>
      </div>
    </section>;
}